var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { runtime } from '../../classes/runtime/Runtime';
import { QuestionTypeName } from '../../classes/learnware/LearnwareEnums';
let QuestionBar_ = class QuestionBar_ extends React.PureComponent {
    render() {
        const { app } = this.props;
        if (app.appInfo.isMobileAppWebView)
            return null;
        if (!runtime.isBrowserRuntime)
            return null;
        if (runtime.isBot)
            return null;
        if (!app.question)
            return null;
        if (runtime.solidBrowserRuntime.browserDevice.isTabletOrSmartphone)
            return null;
        if (app.appMeasure.appWidthInPixel - app.stage.stageInnerMeasure.stageWidthInPixel < 160)
            return null;
        if (app.appMode.isInEditMode)
            return null;
        if (app.question.questionType === QuestionTypeName.CycleEnd) {
            if (!runtime.streamedPackages.Lazy)
                return null;
            const { QuestionBarCycleEnd } = runtime.availablePackages.Lazy.components;
            return React.createElement(QuestionBarCycleEnd, { question: app.solidQuestion });
        }
        if (!runtime.availablePackages.Defer)
            return null;
        const { QuestionBarDefer } = runtime.availablePackages.Defer.components;
        return React.createElement(QuestionBarDefer, { app: app });
    }
};
QuestionBar_ = __decorate([
    observer
], QuestionBar_);
export { QuestionBar_ };
